//1. Open this if you need to build for UAT
// export const BASE_URL = "https://tml-poi-dev-api-appservice.azurewebsites.net";
export const BASE_URL = "https://api-taxspace-dev.tatamotors.com";
// export const BASE_URL = "https://api-taxspace.tatamotors.com";




//2. Open this if you need to build for dev --5175
//export const BASE_URL = ""; //comment this